import { useState } from 'react'
import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { PencilIcon } from 'lucide-react'

import { Button } from '@ems/ui/components/button'

import { sessionQuery } from '#admin/features/auth/queries.ts'
import { hasPlatformScope } from '#admin/features/platform/api.ts'
import { OwnersCard } from '#admin/features/platform/tenants/owners-card.tsx'
import { TenantOverview } from '#admin/features/platform/tenants/overview.tsx'
import { tenantQuery } from '#admin/features/platform/tenants/queries.ts'
import { SettingsDialog } from '#admin/features/platform/tenants/settings-dialog.tsx'

/** `/platform/tenants/$tenantId` — the edition at a glance. */
export const Route = createFileRoute('/_authenticated/platform/tenants/$tenantId/')({
  component: OverviewTab,
})

function OverviewTab() {
  const { tenantId } = Route.useParams()
  const { data: tenant } = useSuspenseQuery(tenantQuery(tenantId))
  const { data: session } = useSuspenseQuery(sessionQuery())
  const [editing, setEditing] = useState(false)
  const canManage = hasPlatformScope(session, 'platform:tenants.manage')

  return (
    <>
      <TenantOverview
        tenant={tenant}
        settingsAction={
          canManage ? (
            <Button variant="outline" size="sm" onClick={() => setEditing(true)}>
              <PencilIcon />
              Edit
            </Button>
          ) : null
        }
      >
        <OwnersCard
          tenant={tenant}
          canImpersonate={hasPlatformScope(session, 'platform:impersonate')}
          selfId={session.user?.id}
        />
      </TenantOverview>
      {canManage ? (
        <SettingsDialog
          // Remounted per open, so it starts from the stored settings every time.
          key={editing ? 'open' : 'closed'}
          open={editing}
          onOpenChange={setEditing}
          tenant={tenant}
        />
      ) : null}
    </>
  )
}
